import React from "react";
import { useTranslation } from "react-i18next";
import Visibility from "../utils/Visibility";
import { indexStore } from "../../store/indexStore";
import { AlertDialogs } from "src/Components/Dialgos/Alter-Daylogs";
import EditSubOptionModel from "src/Components/pages/options/subOption/EditSubOptionModel";
import { Edit, Trash2, DollarSign } from "lucide-react";
import { Button } from "../ui/button";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";

function SubOptionRow(props) {
  const { nameLang, deleteSubOptionFunction, setSubOption } = indexStore();
  const { t } = useTranslation();
  
  const onDelete = (element) => {
    deleteSubOptionFunction(element);
  };
  
  const editRow = (element) => {
    setSubOption(element);
  };
  
  return (
    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg border hover:bg-muted transition-colors group">
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm text-foreground line-clamp-1">
          {props[nameLang] || t("gloabl.sub_option")}
        </p>
      </div>
      
      <div className="flex items-center gap-3">
        <Visibility visible={props.price != 0}>
          <div className="flex items-center gap-1 px-2 py-1 bg-green-50 dark:bg-green-950/30 rounded-md border border-green-200 dark:border-green-800">
            {props.price > 0 && (
              <span className="text-xs text-green-600 font-medium">+</span>
            )}
            <UAEDirhamIcon className="w-3 h-3 text-green-600" />
            <span className="text-sm font-bold text-green-600" dir="ltr">
              {Number(props.price).toFixed(2)}
            </span>
          </div>
        </Visibility>
        <Visibility visible={props.price == 0}>
          <div className="px-2 py-1 text-xs text-muted-foreground">
            {t("gloabl.free") || "Free"}
          </div>
        </Visibility>
        
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <EditSubOptionModel
            trigger={
              <Button
                variant="ghost"
                size="sm"
                className="h-8 w-8 p-0"
                onClick={() => editRow(props)}
              >
                <Edit className="w-4 h-4" />
              </Button>
            }
          />
          <AlertDialogs
            trigger={
              <Button
                variant="ghost"
                size="sm"
                className="h-8 w-8 p-0 text-destructive hover:text-destructive"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            }
            variant="icon"
            onClickOk={() => onDelete(props)}
            description={<span>{t("gloabl.deleteMessage")}</span>}
            title={`${t("gloabl.delete")} ${t("gloabl.sub_option")}`}
          />
        </div>
      </div>
    </div>
  );
}

export default SubOptionRow;
